import { AlertProps, SnackbarProps } from "@mui/material";
import { keyNotification, useStore } from "hooks/useStore";

interface StoreValues {
  props: SnackbarProps & AlertProps & { errors?: string[] };
  setValue: (key: keyof StoreValues, value: unknown) => void;
}

export default function useNotifications() {
  const { props, setValue }: StoreValues = useStore(
    (store) => store[keyNotification],
  );

  const setNotification = (
    props: SnackbarProps & AlertProps & { errors?: string[] },
  ) =>
    setValue("props", {
      autoHideDuration: 6000,
      severity: "success",
      variant: "filled",
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
      open: true,
      onClose: resetNotification,
      ...props,
    });

  const resetNotification = () =>
    setNotification({
      action: undefined,
      severity: undefined,
      message: undefined,
      errors: undefined,
      variant: "outlined",
      open: false,
    });

  return {
    resetNotification,
    setNotification,
    props,
  };
}
